var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalPostsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "totalPostsIcon",
    transform: "translate(1629.217 6440.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M0,78V27.147H.028V0H61.445V27.147H78V78Z",
    transform: "translate(-1628.717 -6439.608)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5054",
    "data-name": "Rectangle 5054",
    width: 26.638,
    height: 12.86,
    transform: "translate(-1612.572 -6424.313)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5054-2",
    "data-name": "Rectangle 5054",
    width: 26.638,
    height: 5.947,
    transform: "translate(-1612.572 -6399.28)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5054-3",
    "data-name": "Rectangle 5054",
    width: 26.638,
    height: 5.947,
    transform: "translate(-1612.572 -6383.473)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11302",
    "data-name": "Path 11302",
    d: "M-1556-6407.131v26.387",
    transform: "translate(-11.376 -0.281)",
    fill: "none",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPostsIcon);
export default __webpack_public_path__ + "static/media/totalPostsIcon.0d02f5ecc210e50708365308ecdbe453.svg";
export { ForwardRef as ReactComponent };